import moment from "moment";

export const getRouteDisplayDate = (route, { includeTime = false } = {}) => {
  if (!route) return "-";

  const date = route.start_date || route.created_at;
  if (!date) return "-";

  const formattedDate = moment(date).format("DD.MM.YYYY");
  if (includeTime && route.start_date) {
    return `${formattedDate} ${moment(date).format("HH:mm")}`;
  }

  return formattedDate;
};

export const getRouteDeparture = (route) => {
  if (!route) return null;

  const routeTiming = route.delivery_timing_config?.delivery_timing || null;
  if (routeTiming) return routeTiming;

  for (const stop of route.pathway ?? []) {
    for (const order of stop?.Orders ?? []) {
      if (order?.departure) return order.departure;
    }
  }

  return null;
};

export const getRouteVrpIdentifier = (route) => {
  if (!route?.vrp_info) return null;

  const info = route.vrp_info;
  if (typeof info === "string" || typeof info === "number") return String(info);

  if (typeof info === "object") {
    return (
      info.identifier ??
      info.id ??
      info.vehicle_id ??
      info.vehicle_index ??
      null
    );
  }

  return null;
};
